import React from 'react'
import { Chip } from '@mui/material'
import format from 'date-fns/format'
import { GridColDef } from '@mui/x-data-grid-premium'
import { Prompt } from 'src/api'
import { InnerLink } from 'src/components/ui'

export namespace PromptColumnsDataGrid {
  export const Title: GridColDef<Prompt> = {
    field: 'title',
    headerName: 'Title',
    type: 'string',
    minWidth: 260,
    flex: 1,
    editable: false,
    renderCell: ({ value, row }) => <InnerLink to={`/prompts/${row.id}`}>{value}</InnerLink>
  }

  export const StartDate: GridColDef<Prompt> = {
    field: 'startDate',
    headerName: 'Start date',
    type: 'date',
    minWidth: 140,
    editable: false,
    valueGetter: ({ value }) => (value ? new Date(value) : null),
    renderCell: ({ value }) => (value ? format(value as Date, 'MMM d, yyyy') : '')
  }

  export const ResponseCount: GridColDef<Prompt> = {
    field: 'responseCount',
    headerName: 'Responses',
    type: 'number',
    minWidth: 120,
    editable: false,
    align: 'left',
    headerAlign: 'left'
  }

  export const Flags: GridColDef<Prompt> = {
    field: 'flags',
    headerName: 'Options',
    sortable: false,
    minWidth: 200,
    editable: false,
    renderCell: ({ row }) => (
      <>
        {row.skippable && <Chip size="small" label="Skippable" sx={{ mr: 0.5 }} />}
        {row.showNewUsers && <Chip size="small" label="New users" sx={{ mr: 0.5 }} />}
        {row.minAppVersion && <Chip size="small" label={`v${row.minAppVersion}`} />}
      </>
    )
  }

  export const CreatedAt: GridColDef<Prompt> = {
    field: 'createdAt',
    headerName: 'Created',
    type: 'date',
    minWidth: 140,
    editable: false,
    valueGetter: ({ value }) => (value ? new Date(value) : null),
    renderCell: ({ value }) => (value ? format(value as Date, 'MMM d, yyyy') : '')
  }
}
